(function (aimi_article, $, app, undefined) {
  // Private object
  var __this = {};
  __this.$body = $('body');
  __this.gridView = 'card';

  app.apis['article'] = function () {
    return {
      'fetch': function (calendarId) {
        return app.getRequest(`/api/calendar/${calendarId}/articles`, {}, function () {
        }, function () {
        });
      },
      'addArticlePost': function (requestData) {
        const calendarId = requestData.calendarId;
        return app.postRequest(`/api/calendar/${calendarId}/article`, requestData, async function (response) {
        }, function () {
        });
      },
      'removeArticlePost': function (articleId) {
        let requestData = {article_id: articleId};
        return app.deleteRequest(`/api/calendar/${__this.calendarId}/article`, requestData, function () {
        }, function () {
        });
      },
      'swap': function (calendarId, postId, articleId) {
        let requestData = {'postId': postId, 'articleId': articleId};
        return app.postRequest(`/api/calendar/${calendarId}/article/swap`, requestData, function () {
        }, function () {
        });
      }
    }
  }();

  /**
   *  view
   */

  aimi_article.view = {
    init: function () {
    }
  }


  aimi_article.saveArticleCallback = function (response) {
    const app = PreBuilt;
    let post = response.post;
    let payload = response.payload;
    console.log(post, payload);
    aimi_article.refresh(app.calendarId).then(async function (listManager) {
      listManager.onRenderList().then(async function (response) {
        app.articlePostContainer.modal('hide');
        const postData = window.calendarPosts[post.id];
        postData.text = payload.text;
        console.log(postData);
        await app.apis['post'].update(postData);
      });

    });
  }

  aimi_article.refresh  = async function (calendarId, posts = null) {
    const $container = $('.articles-container');
     return new ArticleList(app, $container, null,  'card',false, {excludePosts : false, swapButton: false, cardFooter : true}, true, true );
  }

  /**
   *  list
   */
  aimi_article.list = {

    rightHeaderMenus: function () {
      return [
        {'icon': 'grid', 'title': 'Grid View', 'id': 'tab_grid_view', layout: 'card', active: true},
        {'icon': 'table', 'title': 'Table', 'id': 'tab_table_view', layout: 'table'},
      ];
    },

    setHeaderTabs: function (tabs) {
      const $container = $('.header-tabs-end');
      $container.empty();
      _.each(tabs, function (tab) {
        const page = _.template(app.templates['global__header-nav-item']);
        const $page = $(page(tab));
        $page.appendTo($container);
      });
    },



    init: function (calendarId) {
      app.postActionsContext = `article-calendar-${calendarId}`;
      const $container = $('.articles-container');
      __this.calendarId = calendarId;

      // Fetch calendar if app calendar empty
      if(app.isEmpty(app.calendar)) {
        app.apis['calendar'].fetch();
      }

      __this.listMananger = new ArticleList(app, $container, null,  'card',false);
      __this.listMananger.onRenderList().then(function (response) {

      });

      this.setHeaderTabs(this.rightHeaderMenus());

      app.observerManager = new ImageObserverManager(app, '.article-card', 'calendar-card-width', $container);
      // To observe resizing for an element
      app.observerManager.observeResize($container[0]);

      $(document).off('click.aimi_article_list_layout_view').on('click.aimi_article_list_layout_view', '[data-layout-view]', function (e) {
        __this.gridView = $(this).data('layout-view');
        __this.listMananger.setView(__this.gridView);
        __this.listMananger = new ArticleList(app, $container, null, 'searchTable');
        __this.listMananger.onRenderList().then(function (response) {
        });
      });

      const articlesEventManager = new EventManager('articles-action', `[data-article-action]`);

      articlesEventManager.addEventListener('click', function () {
        let $this = $(this);
        const action = $this.data('article-action');
        const $item = $this.closest('.article-item');
        const articleId = $item.data('id');
        console.log(articleId);
        console.log(window.articlePosts)
        const data = window.articlePosts[`${articleId}`];
        if (action === 'add-to-calendar') {
          new ArticlePost(app, articleId, data);
        }

      });

      $(document).off('click.aimi_article_list_layout_view').on('click.aimi_article_list_layout_view', '[data-layout-view]', function (e) {
        __this.gridView = $(this).data('layout-view');
        console.log(__this.gridView);
        __this.listMananger = new ArticleList(app, $container, null,  __this.gridView,'searchTable');
        __this.listMananger.onRenderList().then(function (response) {
        });
      });

      app.initSimpleBar(document.getElementById('tab_block_1'));

    }
  }

  aimi_article.updateCallBack = function (response) {
    response.message = 'article saved successfully';
    app.notifyEl.update({'message': response.message, progress: 90});
    aimi_article.list.renderList().then(function () {
      aimi_article.view.setValues(window.articles[response.id]);
    });
  }

}(window.aimi_article = window.aimi_article || {}, jQuery, PreBuilt));
